import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=0fbf0176"
import script from "./base-info.vue?vue&type=script&lang=js"
export * from "./base-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports